import { Component, OnInit } from '@angular/core';
import { BrandService } from '../Services/brand';
import { Brand } from '../Models/brand';

@Component({
  selector: 'list-brands',
  templateUrl: '../Templates/brand.list.html',
  styleUrls: ['../Styles/brand.component.scss'],
})

export class BrandListComponent implements OnInit {

  brands: Brand[];
  brandsGrouped: { [character: string]: Brand[] } = {};

  constructor(private brandService: BrandService) { }

  brandKeys(): string[] {
    return Object.keys(this.brandsGrouped).sort();
  }

  getBrands(): void {
    let isLetter = /^[a-z]{1}$/;
    let restCategory = '#';

    this.brandService.list()
    .subscribe(data => {
      this.brands = data['results'];
      for (let b of this.brands) {
	if (b.name.length) {
	  // take first character from brand name and use it the group them
	  // if first char is not in a-z we use a '#' to group them
	  let first = b.name.charAt(0).toLowerCase();
	  if (!first.match(isLetter)) {
	    first = restCategory;
	  }
	  if (first in this.brandsGrouped) {
	    this.brandsGrouped[first].push(b);
	  } else {
	    this.brandsGrouped[first] = [b];
	  }
	}
      }
    });
  }

  ngOnInit() {
    this.getBrands();
  }

}



// WEBPACK FOOTER //
// ./src/app/Components/brand.list.ts